/**
 * 提供 web-native 异步 sendRequest 方法
 * **/

/**
 *  返回码                          描述
 *    0         成功
 *    -1        api未授权
 *    -2        参数错误（只是api验证，如果是委托native发起网络请求，服务器返回的参数错误，不是这个返回码）
 *    -3        不支持的api
 *    -4        取消
 *    -5        无网络
 *    -6        超时
 *    -7        服务器错误
 *    -8        失败（未知错误） 建议定义枚举
 * */

import Vue from 'vue';
import router from '../router';
import store from '../store';
import {
	isEmpty,
	isFun,
	removeAllLineBreak,
	removeBr,
	replaceAllLineBreakWithBr,
	resExpHtml,
	webNative
} from '../utils/api';

const vue = new Vue({
	router,
	store
});

export default params => {
	if (params.pending) {
		vue.$store.commit('fetchPending');
	}

	if (params.loading) {
		// 调用APP的转菊花等待
		vue.$app.showTip({
			isIndictorShow: 1,
			hideAfterSecond: 15,
			userInteractionEnabled: 1
		});
	}

	// 生成时间戳和随机字符
	const timestamp = new Date().getTime();
	const random_str = Math.random().toString(36).substr(2);

	// 默认给 body
	isEmpty(params.body) && (params.body = {});

	// 解析以字符串形式传固定参数结构
	// @constant_key: 'json_user_register'
	if (!isEmpty(params.constant_key)) {
		const ck_array = params.constant_key.split('_');
		const constant_key_val = {
			app: ck_array[0],
			mod: ck_array[1],
			act: ck_array[2]
		};

		// 合并body
		params.body = Object.assign({}, constant_key_val, params.body);
	}

	// 兼容 旧版本回放 如果带了 type === 0，则请求头带type
	if (vue.$route.name === 'roadshow_record' && vue.$route.query.type === '0') {
		params.body.type = '0';
	}

	function handleRes(res) {
		// 去除多余的<br/>和替换换行符为<br/>
		res = params.keepAllLine
			? JSON.parse(res)
			: resExpHtml(res)
				? JSON.parse(removeAllLineBreak(res))
				: JSON.parse(replaceAllLineBreakWithBr(removeBr(res)));
		// 向APP发送请求成功
		if (!Number(res.code)) {
			// 调用服务器成功
			// res.data.response 服务器返回对象
			successCallback(res.data.response, params);
		} else if (Number(res.code === -1)) {
			vue.$app.showTip({
				text: '无权限的域名',
				hideAfterSecond: 2
			});
			params.networkFail && params.networkFail(res);
		} else if (Number(res.code) === -2) {
			vue.$app.showTip({
				text: '参数错误',
				hideAfterSecond: 2
			});
			params.networkFail && params.networkFail(res);
		} else if (Number(res.code) === -3) {
			vue.$app.showTip({
				text: '版本太低，升级提示',
				hideAfterSecond: 2
			});
			params.networkFail && params.networkFail(res);
		} else if (Number(res.code) === -5) {
			vue.$app.showTip({
				text: '网络异常，请检查后重试',
				hideAfterSecond: 2
			});
			params.networkFail && params.networkFail(res);
		} else if (Number(res.code === -6)) {
			vue.$app.showTip({
				text: '请求超时',
				hideAfterSecond: 2
			});
			params.networkFail && params.networkFail(res);
		} else if (Number(res.code) === -7) {
			vue.$app.showTip({
				text: '连接服务异常，请稍后再试',
				hideAfterSecond: 2
			});
			params.networkFail && params.networkFail(res);
		} else if (Number(res.code) === -8) {
			vue.$app.showTip({
				text: '未知错误',
				hideAfterSecond: 2
			});
			params.networkFail && params.networkFail(res);
		}
	}
	if (!window.cmi) {
		window.cmi = {};
	}
	/* 定义app onSendRequest 的回调 */
	cmi['onSendRequest_' + random_str + '_' + timestamp] = res => {
		handleRes(res);
	};

	/* 调用 web-native
	 *	"access":"access token",//如果是第三方的 需要带assessToken 鉴定授权
	 */
	webNative({
		access: params.access || '1',
		method: 'sendRequest',
		param: {
			id: random_str + '_' + timestamp,
			request: params.body
		},
		callback: 'cmi.onSendRequest_' + random_str + '_' + timestamp
	});
};

function successCallback(res, params) {
	vue.$app.hideTip();
	vue.$store.commit('fetchPendingSuccess');
	const code = res.errorcode || res.code;

	// @s_cb 成功回调 默认传成功时数据和extra数据
	if (!Number(code)) {
		if (params.success !== undefined) {
			if (isFun(params.success)) {
				if (typeof res.data !== 'undefined') {
					params.success(res.data, res.extra);
				} else {
					params.success(res);
				}
				return;
			}

			alert('回调格式都错了，为：' + params.success);
		}
	} else {
		// 用户账号状态已经在app内处理了
		const extra = res.extra;
		const desc = res.errordesc || res.desc || res.msg;
		const errorData = res.data;

		/* 处理一些页面上的404 错误 */
		if (params.error && code !== '301' && code !== '901' && code !== '2103' && code !== '1502' && code !== '1512') {
			params.error(code, desc, extra, errorData);
		} else {
			if (code === '301' || code === '901' || code === '2103' || code === '1502' || code === '1512') {
				location.replace('/mobile/404?errorcode=' + code);
			} else {
				!params.hideMessage &&
					vue.$app.showTip({
						text: desc,
						hideAfterSecond: 2
					});
			}
		}
		params.error2 && params.error2(code, desc, extra, errorData);
	}
}
